import DetailsModalReview from './details-modal-review'

export default DetailsModalReview
